import {Entity} from 'app/core/main.entity';
import {SwitchItem} from './switch.entity';

export class Position extends Entity {
  id?: number;
  name: string;

  // eslint-disable-next-line @typescript-eslint/naming-convention
  post_code: string;

  // some shitty properties, no idea what for
  categories?: any;
  specialties?: any;

  get postCode() {
    return this.post_code;
  }

  set postCode(postCode) {
    this.post_code = postCode;
  }

  getSwitchItem(): SwitchItem {
    // const item = new SwitchItem(this.postCode, this.name);
    // item.;

    return {
      id: this.postCode,
      title: this.name,
      data: {
        type: 'position'
      }
    };
  }
}
